// FollowButton.tsx
import React, { SyntheticEvent } from "react";
import { Button, Reveal } from "semantic-ui-react";
import { Profile } from "../../app/models/Profile";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import { useTranslation } from "react-i18next";

interface Props{
    profile:Profile;
}

export default observer( function FollowButton({profile}:Props){

    const{userStore, profileStore} = useStore();
    const{updateFollowing, loading} = profileStore;
    const { t } = useTranslation();

    if(userStore.user?.userID === profile.userID) return null;

    function handleFollow(e: SyntheticEvent, userID: string) {
        e.preventDefault();
        profile.following ? updateFollowing(userID, false) : updateFollowing(userID, true);
    }

    const buttonStyle = {
        fontSize: 'clamp(0.7rem, 2vw, 0.9rem)',
        padding: 'clamp(0.5rem, 1.5vw, 0.8rem) clamp(0.8rem, 2vw, 1rem)',
        width: '100%',
        minWidth: '0',  // Changed from '180px' to '0'
        maxWidth: '100%'
    };

    return(
        <Reveal animated="move">
            <Reveal.Content visible style={{ width: '100%' }}>
              <Button 
                color="teal" 
                content={profile.following ? t('followButton.following') : t('followButton.notFollowing')}
                style={buttonStyle}
              />
            </Reveal.Content>

            <Reveal.Content hidden style={{ width: '100%' }}>
              <Button
                color={profile.following ? 'red' : 'green'}
                content={profile.following ? t('followButton.unfollow') : t('followButton.follow')}
                loading={loading}
                onClick={(e) => handleFollow(e, profile.userID)}
                style={buttonStyle}
              />
            </Reveal.Content>
          </Reveal>
    )
})